
    export const NewApplicationStyles = {
        marginBottom: (theme) => theme.spacing(3)
    },
    NewApplicationButtonStyles = {
        marginTop: (theme) => theme.spacing(2),
        marginBottom: "10px"
    },
    DropdownStyles = {
        marginTop: (theme) => theme.spacing(4)
    }
